//for colors that are used in multiple components 

export const commonColors = {
    profit: '#43A646',
    loss: '#ed3237',
    meterBar: '#b1b1b1',
    lightThemeText: '#7e7e7e',
    darkThemeText: '#ffffff',
    darkThemeBackground: '#1d1d1d',
    lightThemeBackground: '#ffffff',
    orderToastLightBackground: '#ffffff',
    orderToastDarkBackground: '#313131',
    orderToastLightText: '#101010',
    orderToastDarkText: '#f2f2f2'
  }
